// services/IosAppleBusinessManagerDataService.js
import http from "../http-common";

class IosAppleBusinessManagerDataService {
  getUnallocatedABMDevices() {
    return http.post("/ios/abm/devices");
  }
  assignDevicesToProfile(data) {
    return http.post("/ios/abm/profile/assign", data);
  }
  saveAutoAssignConfig(data) {
    return http.post("/ios/abm/auto-assign/config", data);
  }
}

export default new IosAppleBusinessManagerDataService();